import { api, del, get, post } from '../client';

function unwrap(res) {
  return res?.data?.data;
}

export const equipmentKycApi = {
  list: (params) => get('/equipment-kyc', { params }),
  getById: (id) => get(`/equipment-kyc/${id}`),
  extractData: (id) => post(`/equipment-kyc/${id}/extract-data`, {}, { timeout: 120000 }),
  update: (id, form) =>
    api
      .patch(`/equipment-kyc/${id}`, form, {
        timeout: 120000,
        transformRequest: [
          (data, headers) => {
            if (typeof FormData !== 'undefined' && data instanceof FormData) {
              delete headers['Content-Type'];
              delete headers['content-type'];
            }
            return data;
          },
        ],
      })
      .then(unwrap),
  remove: (id) => del(`/equipment-kyc/${id}`),
};
